<div   class="demo py-5 "   [ngStyle]="{'background-image': 'url(' + coverPrefix + moviesDetails.backdrop_path+ ')'}">     
    <div class="demo2 container my-5">
    
        <div class="row">
            <div class="col-md-8 d-flex align-content-around flex-wrap">
                <div class=" demo3 caption m-5 " >
        
        
                
                    <h1 class="title">{{moviesDetails.original_title}}</h1>
                    <p class="tagline"> {{moviesDetails.tagline}} </p>
    
                    <p class="text-justify w-75"> {{moviesDetails.overview}}</p>
                    <p> <span class="detailsHeader">release_date:</span> {{moviesDetails.release_date}}</p>
                
                    <p> <span class="detailsHeader">vote_count:</span>{{moviesDetails.vote_count}} </p>
                
                
                
                
                </div>
                
            </div>
            
            <div class="col-md-4 my-5">
            <div class="px-5">
                <div class="rate">
                    <button class="btn btn-warning"> {{moviesDetails.vote_average}}</button>
        
                </div>
        
                <img [src]="imgPrefix + moviesDetails.poster_path"  class="imgPoster m-auto img-fluid" alt="">
            </div>
            </div>
        
        </div>
            
    
    
    </div>  
</div>








<section class="x container my-5">


<div class="cast">
    <h2 class="header text-center my-5"> <span>***************</span>  Cast <span>***************</span></h2>

    <div class="row">
        
    <div *ngFor="let x of cast" class="col-md-2  col-sm-3  my-3 py-5">
    
        <img [src]=" imgPrefix+x.profile_path"  class="img-fluid" alt="">
        <h5>{{x.name}}</h5>
    </div>
    </div>

</div>

<div class="row">
  
    <div class="col-md-12 ">
        
    <h2 class="header text-center my-5"> <span>***************</span> Official Trailer <span>***************</span></h2>

    <iframe class="w-100 " height="500" [src]="url | safe"  allowfullscreen></iframe>
    </div>

</div>

</section>
